import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import necrolog from '../images/necrolog.jpg';
import gregory from '../images/gregory.jpg';
import taras from '../images/taras.jpg';
import materials from '../images/materials.jpg';
import boscohistory from '../images/boscohistory.jpg';
import Heading from '../Heading';

const IntrevyuZSaleziyaninom = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <>
      <section className="pb-20">
        <div className="container">
          <Heading name="Інтерв'ю з салезіянином" />
          <div className="grid grid-cols-1 gap-4 md:grid-rows-2 md:grid-cols-2">
            <div className="relative">
              <iframe
                className="!rounded-xl w-full h-[190px] md:h-[355px]"
                src="https://www.youtube.com/embed/qbGuRlcm0TQ"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="relative">
              <iframe
                className="!rounded-xl w-full h-[190px] md:h-[355px]"
                src="https://www.youtube.com/embed/UXFq7ztj4t4"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="relative">
              <iframe
                className="!rounded-xl w-full h-[190px] md:h-[355px]"
                src="https://www.youtube.com/embed/XactrQaKPbo"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="relative">
              <iframe
                className="!rounded-xl w-full h-[190px] md:h-[355px]"
                src="https://www.youtube.com/embed/e1KyJ0I8GR8"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default IntrevyuZSaleziyaninom;
